import React from 'react';
import SearchBox from '../../../../../components/outline/SearchBox';
import BaseForm from '../../../../../components/form/BaseForm';
import Input from '../../../../../components/input/Input';
import DateRangePicker from '../../../../../components/datePicker/DateRangePicker';
import CountOfTotal from '../../../../../components/CountOfTotal';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import { REMOTE_IMAGE_SPLASH_LIST_SEARCH_OPTION_MODEL } from '../../../../../store/modules/remoteImage/models';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import { MAXIMUM_NUMBER_OF_REMOTE_IMAGE_LIST_SEARCH_MEMO } from '../../../../../constants/service/app/remoteImageConstants';
import './RemoteImageSplashSearchBox.scss';

const RemoteImageSplashSearchBox = (props) => {
  const { searchData, setData, getList } = props;
  const { memo, createDate } = searchData;

  return (
    <SearchBox
      className="remote-image-search-box"
      onSearch={() =>
        getList({
          searchOption: searchData,
          pagination: _LIST_PAGINATION_MODEL,
        })
      }
      onClear={() => {
        getList({
          searchOption: [],
          pagination: _LIST_PAGINATION_MODEL,
        });
        setData({
          path: [],
          value: REMOTE_IMAGE_SPLASH_LIST_SEARCH_OPTION_MODEL,
        });
      }}
    >
      <BaseForm
        label={
          <span>
            <span>메모</span>
            <CountOfTotal content={memo} maxCnt={MAXIMUM_NUMBER_OF_REMOTE_IMAGE_LIST_SEARCH_MEMO} />
          </span>
        }
        content={
          <Input
            value={memo}
            onChange={(value) =>
              setData({
                path: ['memo'],
                value,
              })
            }
            onPressEnter={() =>
              getList({
                searchOption: searchData,
                pagination: _LIST_PAGINATION_MODEL,
              })
            }
            maxLength={MAXIMUM_NUMBER_OF_REMOTE_IMAGE_LIST_SEARCH_MEMO}
            size="large"
          />
        }
      />

      <BaseForm
        label={'스플래시 이미지 생성일'}
        content={
          <DateRangePicker
            value={createDate}
            format={DATE_FORMAT.YMD_DASH_FORMAT}
            outFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            btnTextFormat={DATE_FORMAT.YMD_DASH_FORMAT}
            onSelect={(value) =>
              setData({
                path: ['createDate'],
                value,
              })
            }
          />
        }
      />
    </SearchBox>
  );
};

export default RemoteImageSplashSearchBox;
